import React, { useState } from 'react';
import { Layout, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import CustomerSearchForm from '../components/CustomerSearchForm';
import CustomerSearchResults from '../components/CustomerSearchResults';
import { useEssenceSearchCustomers } from '../api/essence-customer-api';
import type { CustomerSearchCriteriaDTO, PageCustomerDTO } from '@/shared/api/model';

const { Content } = Layout;

const CustomerManagementView: React.FC = () => {
  const navigate = useNavigate();
  const [searchCriteria, setSearchCriteria] = useState<CustomerSearchCriteriaDTO>({ page: 0, size: 20 });
  const [searchResults, setSearchResults] = useState<PageCustomerDTO | null>(null);

  const searchMutation = useEssenceSearchCustomers({
    mutation: {
      onSuccess: (data) => {
        setSearchResults(data);
      },
      onError: () => {
        message.error('Failed to search customers');
      },
    },
  });

  const handleSearch = (criteria: CustomerSearchCriteriaDTO) => {
    setSearchCriteria(criteria);
    searchMutation.mutate({ data: criteria });
  };

  const handleViewCustomer = (branch: string, custNo: string) => {
    navigate(`/customers/manage/${branch}/${custNo}`);
  };

  const handlePageChange = (page: number, pageSize: number) => {
    handleSearch({ ...searchCriteria, page, size: pageSize });
  };

  return (
    <Layout>
      <Content style={{ padding: '24px' }}>
        <CustomerSearchForm onSearch={handleSearch} loading={searchMutation.isPending} />
        <div style={{ marginTop: 24 }}>
          <CustomerSearchResults
            data={searchResults}
            loading={searchMutation.isPending}
            onViewCustomer={handleViewCustomer}
            onPageChange={handlePageChange}
          />
        </div>
      </Content>
    </Layout>
  );
};

export default CustomerManagementView;
